/* Privatefun — vier dingen aan de navigatiebalk en het laden van beelden.

   1. Mobiel submenu als accordeon.
      Het uitklapmenu onder "Producten" was een lijst van 36 links achter elkaar: 1194px
      hoog op een scherm van 812px. Onder 750px klappen de zes werelden nu dicht; er staat
      er altijd maar een open. Boven 750px verandert er niets.

   2. De balk op telefoon altijd in beeld.
      Het plakken zelf doet de browser met position: sticky, zie pf-fixes-4.css blok 4.
      Dit script meet alleen hoeveel er bovenlangs weg mag schuiven en zet dat in --pf-plak.
      Eén meting bij het laden, en opnieuw als er iets van maat verandert — niet tijdens het
      scrollen, want daar zat nou juist de fout die dit moest oplossen.

      Ook de tekst in het zoekveld hoort hierbij: op telefoon is er geen ruimte voor de
      volledige zin en die werd afgekapt.

   3. Telefoonnummer uitgeschreven in de bovenbalk op desktop.
      De sectie heeft geen instelling voor een telefoonnummer, dus die link wordt hier
      toegevoegd. Alleen boven 901px — op telefoon is er geen ruimte.

   4. Beeldvakken: het grijze vlak weghalen en foto's asynchroon laten decoderen.
      Het grijs staat in de CSS zodat het er al is bij de eerste paint; dit script haalt het
      weg zodra de foto er staat. En het zet decoding="async" op elke foto, zodat het
      decoderen het tekenen van de pagina niet ophoudt. */
(function () {
  'use strict';

  var MOBIEL = '(max-width: 749px)';
  /* Dezelfde grens als de @media-regels in pf-fixes-4.css. Wijkt die af, dan meet het
     script iets anders dan de browser tekent. */
  var TELEFOONGRENS = '(max-width: 900px)';
  var DESKTOP = '(min-width: 901px)';
  var OPEN = 'pf-open';
  var TELEFOON = '+31475480311';
  var TELEFOON_TEKST = '+31 475 48 03 11';

  /* ---------------- 1. accordeon ---------------- */

  function isKop(el) {
    if (!el || !el.className || typeof el.className !== 'string') return false;
    return el.className.indexOf('__heading') !== -1;
  }

  function kopVanEvent(target) {
    var el = target;
    while (el && el !== document.body) {
      if (isKop(el)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function zetAria(kolom, open) {
    var kop = kolom.querySelector('[class*="__heading"]');
    if (kop) {
      kop.setAttribute('role', 'button');
      kop.setAttribute('tabindex', '0');
      kop.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function klap(kolom) {
    var container = kolom.parentElement;
    var stondOpen = kolom.classList.contains(OPEN);
    if (container) {
      var broers = container.children;
      for (var i = 0; i < broers.length; i++) {
        broers[i].classList.remove(OPEN);
        zetAria(broers[i], false);
      }
    }
    if (!stondOpen) {
      kolom.classList.add(OPEN);
      zetAria(kolom, true);
    }
  }

  function behandel(event) {
    if (!window.matchMedia(MOBIEL).matches) return;
    var kop = kopVanEvent(event.target);
    if (!kop) return;
    if (!kop.closest('[class*="__panel"]')) return;
    var kolom = kop.parentElement;
    if (!kolom || !kolom.querySelector('[class*="__list"]')) return;
    event.preventDefault();
    klap(kolom);
  }

  document.addEventListener('click', behandel, true);

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!kopVanEvent(event.target)) return;
      behandel(event);
    },
    true
  );

  function markeerKoppen() {
    if (!window.matchMedia(MOBIEL).matches) return;
    var panelen = document.querySelectorAll('[class*="__panel"]');
    for (var i = 0; i < panelen.length; i++) {
      var koppen = panelen[i].querySelectorAll('[class*="__heading"]');
      for (var j = 0; j < koppen.length; j++) {
        var kolom = koppen[j].parentElement;
        if (kolom && kolom.querySelector('[class*="__list"]')) {
          zetAria(kolom, kolom.classList.contains(OPEN));
        }
      }
    }
  }

  /* ---------------- 2. de balk vastplakken ----------------

     Het plakken doet de browser, met position: sticky op #header-group. Zie pf-fixes-4.css
     blok 4 voor waarom dat daar zit en niet op de balk zelf.

     Sticky heeft één getal nodig: hoe ver de groep boven de schermrand uit mag schuiven
     voordat hij blijft hangen. Dat is de afstand van de bovenkant van de groep tot de
     bovenkant van de balk, met een minteken ervoor. Boven die lijn zitten de
     aankondigingsbalk en de iconenregel; die mogen wegschuiven. Gemeten op 375px:
     30 + 40 = 70, dus --pf-plak wordt -70px.

     Het verschil tussen twee getBoundingClientRect-en is onafhankelijk van de scrollstand,
     dus dit klopt ook als de groep op dat moment al vastgeplakt staat. Er is geen enkele
     reden om dit tijdens het scrollen te herhalen — en precies dat herhalen was de fout die
     dit blok vervangt.

     Wel opnieuw meten als er iets van maat verandert: een gedraaid toestel, een lettertype
     dat later binnenkomt, het logo dat zijn hoogte pas kent als de afbeelding er is. Daar is
     de ResizeObserver voor. */

  function plakDelen() {
    var groep = document.querySelector('#header-group');
    if (!groep) return null;
    var top = groep.querySelector('[data-top]');
    if (!top) return null;
    var balk = top.querySelector('[class*="__main"]');
    if (!balk) return null;
    return { groep: groep, top: top, balk: balk };
  }

  function meetPlak() {
    var d = plakDelen();
    if (!d) return;

    if (!window.matchMedia(TELEFOONGRENS).matches) {
      d.groep.style.removeProperty('--pf-plak');
      return;
    }

    var afstand = Math.round(
      d.balk.getBoundingClientRect().top - d.groep.getBoundingClientRect().top
    );

    /* Een negatieve afstand kan niet en betekent dat er iets anders aan de hand is — dan
       liever niets zetten en op de terugval van 0px landen dan een onzinnige waarde. */
    if (afstand < 0) return;

    d.groep.style.setProperty('--pf-plak', -afstand + 'px');
  }

  function startPlak() {
    var d = plakDelen();
    if (!d) return;
    meetPlak();

    if (!window.ResizeObserver) return;
    var waarnemer = new ResizeObserver(function () {
      meetPlak();
    });
    waarnemer.observe(d.groep);
    waarnemer.observe(d.top);
  }

  /* ---------------- 2b. de tekst in het zoekveld ----------------

     "Waar ben je naar op zoek?" is ongeveer 185px breed. Het invoerveld op telefoon is dat
     niet: gemeten op 375px blijft er na de hamburger en het logo zo'n 90px over. De zin werd
     dus midden in een woord afgekapt.

     Korter maken is de enige uitweg die geen van de andere drie dingen — hamburger, logo,
     zoekknop — kleiner maakt. Op desktop blijft de volledige zin staan; die wordt hier
     bewaard zodat draaien naar liggend hem weer terugzet. */

  var ZOEK_KORT = 'Zoeken';

  function zetZoektekst() {
    var veld = document.querySelector('[data-top] [class*="__search"] input');
    if (!veld) return;

    if (typeof veld.dataset.pfZoek !== 'string') {
      veld.dataset.pfZoek = veld.getAttribute('placeholder') || '';
    }

    var kort = window.matchMedia(TELEFOONGRENS).matches;
    veld.setAttribute('placeholder', kort ? ZOEK_KORT : veld.dataset.pfZoek);
  }

  /* ---------------- 3. telefoonnummer op desktop ---------------- */

  function zetTelefoon() {
    if (!window.matchMedia(DESKTOP).matches) return;
    var balk = document.querySelector('[class*="__utility-right"]');
    if (!balk || balk.querySelector('[data-pf-tel]')) return;

    var voorbeeld = balk.querySelector('[class*="__util-link"]');
    var link = document.createElement('a');
    link.href = 'tel:' + TELEFOON;
    link.setAttribute('data-pf-tel', '');
    link.setAttribute('aria-label', 'Bel ons op ' + TELEFOON_TEKST);
    if (voorbeeld) link.className = voorbeeld.className;

    link.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<path d="M6.5 3h3l1.5 4-2 1.5a12 12 0 0 0 5.5 5.5L16 12l4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4 6.2 2 2 0 0 1 6 4z"/>' +
      '</svg>';
    link.appendChild(document.createTextNode(TELEFOON_TEKST));

    balk.insertBefore(link, balk.firstChild);
  }

  /* ---------------- 4. beeldvakken: grijs weghalen en decoding losmaken ----------------

     Twee dingen per fotovak.

     .pf-geladen gaat op het vak zodra de foto er is. pf-fixes-4.css blok 5 verbergt tot dan
     de alt-tekst (het grijze laadvlak dat daar vroeger ook aan hing is weg, oktober 2026).

     En elke foto krijgt decoding="async". Dat stond op "auto", en dat laat de browser zelf
     kiezen — Safari kiest dan regelmatig voor synchroon decoderen, midden in het tekenen van
     het beeld. Zolang die decodering loopt kan het stuk scherm eronder niet af, en zie je
     wit dat zich een seconde later alsnog vult. Op een collectiepagina staan 28 foto's die
     bij het scrollen vrijwel tegelijk in beeld komen; op een productpagina één. Dat is
     precies het verschil tussen waar het wel en niet misgaat.

     Met async mag de browser het vak alvast tekenen en de foto erin zetten zodra hij klaar
     is. Het zetten werkt alleen zolang de foto nog niet geladen is, en dat is hier het
     geval: alles onder de vouw staat op loading="lazy" en begint pas als je erheen scrollt.
     Dit script draait ruim daarvoor.

     Niet naar de eerste foto in het vak kijken. Een productkaart bevat alle variantfoto's —
     gemeten: vijf img-elementen waarvan er precies één breedte heeft. De andere vier laden
     nooit, dus wachten op de eerste is wachten op iets dat niet komt. Daarom luisteren we
     op het vak zelf in de capture-fase: load bubbelt niet omhoog vanaf een img, maar hij
     daalt wel af, en zo vangen we welke foto er ook maar als eerste klaar is.

     De tijdslimiet van acht seconden is het vangnet. Laadt er werkelijk niets, dan is een
     leeg vak beter dan een grijze vlek die er voorgoed blijft staan.

     Kaarten die later binnenkomen — filteren, volgende pagina, quick add — worden door de
     observer opgepikt. */

  var SKELETVAKKEN = [
    '.bestsellers-section [class*="__media"]',
    '.pf-subcats-section [class*="__vak"]',
    'product-card .card-gallery',
    '.product-grid .card-gallery',
    '.product-media-container .product-media'
  ].join(',');

  function volgVak(vak) {
    if (vak.dataset.pfSkelet) return;
    vak.dataset.pfSkelet = '1';

    var afgerond = false;
    var klaar = function () {
      if (afgerond) return;
      afgerond = true;
      vak.classList.add('pf-geladen');
      vak.removeEventListener('load', klaar, true);
      vak.removeEventListener('error', klaar, true);
    };

    var fotos = vak.querySelectorAll('img');
    if (!fotos.length) {
      klaar();
      return;
    }

    for (var i = 0; i < fotos.length; i++) {
      if (fotos[i].decoding !== 'async') fotos[i].decoding = 'async';
    }

    for (var i = 0; i < fotos.length; i++) {
      if (fotos[i].complete && fotos[i].naturalWidth > 0) {
        klaar();
        return;
      }
    }

    vak.addEventListener('load', klaar, true);
    vak.addEventListener('error', klaar, true);
    setTimeout(klaar, 8000);
  }

  function zoekVakken(binnen) {
    var wortel = binnen && binnen.querySelectorAll ? binnen : document;
    var vakken = wortel.querySelectorAll(SKELETVAKKEN);
    for (var i = 0; i < vakken.length; i++) volgVak(vakken[i]);
    if (binnen && binnen.matches && binnen.matches(SKELETVAKKEN)) volgVak(binnen);
  }

  function startSkeletons() {
    zoekVakken(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (lijst) {
      for (var i = 0; i < lijst.length; i++) {
        var toegevoegd = lijst[i].addedNodes;
        for (var j = 0; j < toegevoegd.length; j++) {
          if (toegevoegd[j].nodeType === 1) zoekVakken(toegevoegd[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- start ---------------- */

  function start() {
    markeerKoppen();
    startPlak();
    zetZoektekst();
    zetTelefoon();
    startSkeletons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', function () {
    meetPlak();
    zoekVakken(document);
  });

  var hertekenTimer = null;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(hertekenTimer);
      hertekenTimer = setTimeout(function () {
        meetPlak();
        zetZoektekst();
        zetTelefoon();
      }, 150);
    },
    { passive: true }
  );
})();
